import React, { useEffect } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { globalActions } from '../store/actions';

interface LayoutProps {
  children?: React.ReactNode;
}

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flex: 1,
    paddingTop: `env(safe-area-inset-top)`,
    paddingBottom: `env(safe-area-inset-bottom)`,
    paddingLeft: `env(safe-area-inset-left)`,
    paddingRight: `env(safe-area-inset-right)`,
  },
}));

const AppLayout: React.FC<LayoutProps> = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(globalActions.syncAllData());
  }, []);

  const { children } = props;

  const classes = useStyles();

  return <Box className={classes.root}>{children}</Box>;
};

export default AppLayout;
